import api from './api';
import authHeader from './auth-header';

class AutomationService {
    getRules() {
        return api.get('/automations', { headers: authHeader() });
    }

    getRule(id) {
        return api.get(`/automations/${id}`, { headers: authHeader() });
    }

    createRule(ruleData) {
        return api.post('/automations', ruleData, { headers: authHeader() });
    }

    updateRule(id, ruleData) {
        return api.put(`/automations/${id}`, ruleData, { headers: authHeader() });
    }

    deleteRule(id) {
        return api.delete(`/automations/${id}`, { headers: authHeader() });
    }

    getRuleExecutions(id, limit, after) {
        const params = new URLSearchParams();
        if (limit) {
            params.append('limit', limit.toString());
        }
        if (after) {
            params.append('after', after.toString());
        }
        const queryString = params.toString();
        const url = `/automations/${id}/executions${queryString ? `?${queryString}` : ''}`;
        return api.get(url, { headers: authHeader() });
    }
}

const automationService = new AutomationService();
export default automationService; 